import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const useAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, loading, user } = useSelector((state) => state.auth);
  const { language, availableLanguages } = useLanguage();

  const getLocalizedPath = (path) => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    const currentLang = pathParts[0];
    const lang = availableLanguages.includes(currentLang) ? currentLang : (language || 'en');
    return `/${lang}${path}`;
  };

  const requireAuth = (callback) => {
    if (!isAuthenticated && !loading) {
      navigate(getLocalizedPath('/login'), { state: { from: window.location.pathname } });
      return;
    }
    if (callback) {
      callback();
    }
  };

  return {
    isAuthenticated,
    isLoading: loading,
    user,
    requireAuth
  };
};

export default useAuth;
